export default __webpack_public_path__ + "static/media/virgin-mobile-logo.4724f7ee.svg";